<div class="d-flex row-cols-12">
    <div class="col-12">
        <h3 class="title float-start" translate="Settings.AddressbookIntegrations"></h3>
    </div>
</div>

<div class="p-4 pt-0">
    <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <ul class="mt-2 w-100 list-group sourceheader rounded-bottom-0">
            <li class="list-group-item subheader d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-12"><span translate="Settings.IntegrationsImportExportSection.Source"></span></div>
                </div>
            </li>
        </ul>
        <ul class="w-100 list-group rounded-0">

            <app-hide-by-permission-wrapper [forPermission]="permissionEnum.Perm_SalesForce">
                <li class="list-group-item d-block py-1">
                    <div class="row w-100 d-flex align-items-center">
                        <div class="col-9 text-truncate float-none form-check form-switch">
                            <input class="switch-form-default float-none form-check-input items" type="checkbox"
                                role="switch" (change)="toggleShowSettings($event)" id="UseSalesforceCrmData"
                                [checked]="orgSettings.UseSalesforceCrmData"
                                [disabled]="orgSettings.UseSimplicateCrmData"
                                [disabledByPermission]="permissionEnum.Perm_SalesForce">
                            <label class="col-10" for="UseSalesforceCrmData"
                                translate="Settings.IntegrationsAddressBookSection.Salesforce">
                                <!-- <app-info-button labelName="Settings.IntegrationsImportExportSection.SalesforceTooltip" [url]="AddressBookUrl" placement="bottom"></app-info-button> -->
                            </label>
                        </div>
                        <div class="col-3 text-end">
                            <div class="btn-group">
                                <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                    <i class="bi bi-three-dots bi-large"></i>
                                </button>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item pt-1 pb-1" (click)="openConfigSalesforceModal()"
                                            translate="Button.Edit"></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </li>
            </app-hide-by-permission-wrapper>
            <app-hide-by-permission-wrapper [forPermission]="permissionEnum.Perm_Simplicate">

                <li class="list-group-item d-block py-1">
                    <div class="row w-100 d-flex align-items-center">
                        <div class="col-9 text-truncate float-none form-check form-switch">
                            <input class="switch-form-default float-none form-check-input items" type="checkbox"
                                role="switch" (change)="toggleShowSettings($event)" id="UseSimplicateCrmData"
                                [checked]="orgSettings.UseSimplicateCrmData"
                                [disabled]="orgSettings.UseSalesforceCrmData"
                                [disabledByPermission]="permissionEnum.Perm_Simplicate">
                            <label class="col-10" for="UseSimplicateCrmData"
                                translate="Settings.IntegrationsAddressBookSection.Simplicate"><app-info-button
                                    labelName="Settings.IntegrationsImportExportSection.SimplicateTooltip"
                                    [url]="AddressBookUrl" placement="bottom"></app-info-button></label>
                        </div>
                        <div class="col-3 text-end">
                            <div class="btn-group">
                                <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                    <i class="bi bi-three-dots bi-large"></i>
                                </button>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item pt-1 pb-1" (click)="openSimplicateModal()"
                                            translate="Button.Edit"></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </li>
            </app-hide-by-permission-wrapper>

        </ul>
    </div>
</div>